import { memo } from "react";
import { Link, useParams } from "react-router-dom";

import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Divider from "@mui/material/Divider";
import Breadcrumb from "@mui/material/Link";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useConnectionByID } from "stores/ConnectionStore";

import JiraConfigInfo from "./ConfigInfo";
import JiraFindingMappings from "./FindingMappings";

const ConfigureJiraIssueSync = memo(function ConfigureJiraIssueSync() {
  const { uuid } = useParams();
  const connection = useConnectionByID(uuid ?? "");
  return (
    <>
      <Breadcrumbs>
        <Breadcrumb
          underline="none"
          color="inherit"
          component={Link}
          to="/environment/destinations"
        >
          Environment
        </Breadcrumb>
        <Breadcrumb
          underline="none"
          color="inherit"
          component={Link}
          to="/environment/destinations"
        >
          Destinations
        </Breadcrumb>
        <span />
      </Breadcrumbs>
      <Box>
        <Typography variant="h4" fontWeight="bold" sx={{ mt: 1 }}>
          Jira Cloud Issue Sync
        </Typography>
        <Typography variant="body1">
          Jira Cloud Issue Sync can be configured to create and maintain
          associations with Jira issues in a particular project.
        </Typography>
      </Box>
      <Divider sx={{ mt: 2, mb: 2 }} />
      {connection === undefined ? (
        <Skeleton height={400} />
      ) : (
        <Stack spacing={2}>
          <JiraConfigInfo connection={connection} />
          <JiraFindingMappings connection={connection} />
        </Stack>
      )}
    </>
  );
});
export default ConfigureJiraIssueSync;
